import { Ajax } from "ajax"
import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "player", "tabPanel" ]
  static values = { mode: String, url: String, cachedMode: String }

  wide() {
    this.modeValue = 'wide'
  }

  standard() {
    this.modeValue = 'standard'
  }

  toggle() {
    if (this.modeValue == 'wide') {
      this.modeValue = 'standard'
    } else {
      this.modeValue = 'wide'
    }
  }

  setPlayersMode() {

    this.playerTargets.forEach((el) => {
      if(this.modeValue == 'wide'){
        el.classList.add('wide-player')
      } else {
        el.classList.remove('wide-player')
      }
    })
  }

  modeValueChanged() {
    this.setPlayersMode()
  
    if (this.modeValue != this.cachedModeValue) {
      this.cachedModeValue = this.modeValue
      
      Ajax.post(this.urlValue, {player_size: this.modeValue}).then(() => {
      }).catch(() => {
        console.log('player mode value change reject')
      });
    }

  }

}